import makeStyles from "@mui/styles/makeStyles";
import { Bold, Regular, SemiBold } from "../../../utils";

export const componentsStyle = makeStyles((theme) => ({
    parentBox: {
        display: "flex",
        justifyContent: "space-between",
        padding: "12px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E4E8EE",
        boxShadow: "0px 0px 24px #00000014",
        borderRadius: "8px",
        alignItems: "center"
    },
    headerParent: {
        marginInlineStart: "10px"
    }
    ,
    header: {
        fontSize:"0.875rem",
        fontFamily: Bold,
        color: "#091B29"
    },
    subHearder: {
        fontFamily: Bold,
        fontSize:"0.75rem",
        color: "#5AC782",
        backgroundColor: "#EEF9EE",
        borderRadius: "4px",
        padding: "4px"
    },
    imgParent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    text2: {
        fontSize:"0.75rem",
        fontFamily: Regular,
        color: "#98A0AC"
    },
    text3: {
        fontSize:"0.875rem",
        fontFamily: SemiBold,
        color: "#5078E1"
    },
    text: {
        fontSize:"1rem",
        fontFamily: Bold,
        color: "#091B29",
        direction: "ltr"
    },
    //uploard card css
    uploadBox: {
        padding: "12px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E4E8EE",
        // boxShadow: "0px 0px 24px #00000014",
        borderRadius: "8px",
    },
    boxSection: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    boxSection2: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 6
    },
    uploadHeader: {
        fontSize:"0.875rem",
        fontFamily: Bold,
        color: "#4E5A6B"
    },
    icon: {
        fontSize:"1rem",
        color: "#98A0AC",
        cursor: "pointer"
    },
    cancelBtn: {
        border: `1px solid #CED3DD`,
        backgroundColor: "white",
        height: "40px",
        color: "#091B29",
        borderRadius: "8px",
        fontSize:"0.875rem",
        fontFamily: Bold,
        "&:hover": {
            backgroundColor: "white",
            border: `1px solid #CED3DD`,

        },
    },
    btn: {

        fontSize:"0.875rem",
        fontFamily: Bold,
        "&:hover": {
            backgroundColor: "inherit",
        },
    },
    saveBtn: {
        borderRadius: "8px",
        height: "40px",
        fontSize:"0.875rem",
        fontFamily: Bold,
        marginLeft: "10px"

    },
    uploadText: {
        fontSize:"0.875rem",
        fontFamily: (props) => props?.link ? SemiBold : Bold,
        color: theme.typography.color.tertiary,
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "noWrap",
        maxWidth: "260px"
    },
    drap2: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        height: "70px",
        borderRadius: "4px",
        textAlign: "center",
        background: "#F5F7FA",
        border: "2px dashed #E4E8EE",
    },
    textAndUpload: {
        marginTop: (props) => props?.data?.link ? "18px" : "10px",
        marginBottom: (props) => props?.data?.link && "6px"
    }
}))